import React, { Component } from 'react';
import API from '@/api/api';
import zhCN from 'antd/es/locale/zh_CN';
import { Table, Button, DatePicker, Select, ConfigProvider, Input } from 'antd';
const { RangePicker } = DatePicker;
const { Option } = Select;

// /insuranceBroker/sharonList

class SharonList extends Component {

  constructor(props) {
    super(props);
  }

  state = {

    columns: [//直播列表表头
      {
        title: '活动ID',
        dataIndex: 'activityId',
      },
      {
        title: '活动名称',
        dataIndex: 'title',
      },
      {
        title: '发布人',
        dataIndex: 'userName',
      },
      {
        title: '活动开始时间',
        dataIndex: 'startTimeFormat',
      },
      {
        title: '活动结束时间',
        dataIndex: 'endTimeFormat',
      },
      {
        title: '报名人员',
        render: (_, record) => (<Button type="primary" onClick={this.lookInvitedUsers.bind(this, record.activityId)}>查看</Button>)
      },
      {
        title: '报名状态',
        dataIndex: 'signStatus',
        render: (signStatus) => (signStatus == 1 ? '截止报名' : '报名中')
      },
      {
        title: '活动状态',
        dataIndex: 'status',
        render: (status) => {
          return status == 1 ? '进行中' : status == 2 ? '已结束' : '未开始'
        },
      }
    ],

    searchCondition: {//直播列表搜索条件
      title: undefined,
      signStatus: undefined, // 0报名中 1截止报名
      status: undefined, // 0 未开 1进行 2 结束
      endTime: undefined,
      startTime: undefined,
      pageSize: 5,
      pageNo: 1,
    },

    pagination: {
      defaultPageSize: 5,
      hideOnSinglePage: true,
      showTotal: total => `总${total}条`,
      onChange: this.onPaginationChange.bind(this),
    },
    timeSelect: '',
  }
  componentDidMount() {
    this.getListData()
  }

  onPaginationChange(page, pageSize) {
    let { searchCondition } = this.state;
    searchCondition.pageNo = page;
    this.setState({ searchCondition }, () => {
      this.getListData()
    })
  }

  onSearchDateChange = (date) => { //筛选条件 ：时间范围
    let { searchCondition } = this.state;
    let startTime = '', endTime = '';
    if (date.length == 0) {
      startTime = '';
      endTime = '';
    } else {
      startTime = Math.floor(date[0].valueOf() / 1000);
      endTime = Math.floor(date[1].valueOf() / 1000);
    }
    searchCondition.startTime = startTime;
    searchCondition.endTime = endTime;
    this.setState({ searchCondition });
  }

  onSelectChange(type, value) {//下拉框更改
    let { searchCondition } = this.state;
    searchCondition[type] = value
    this.setState({ searchCondition })
  }

  searchForData(type) {
    let { searchCondition } = this.state;
    if ('reset' === type) {
      searchCondition = {
        title: undefined,
        signStatus: undefined, // 0报名中 1截止报名
        status: undefined, // 0 未开 1进行 2 结束
        endTime: undefined,
        startTime: undefined,
        pageSize: 5,
        pageNo: 1,
      }
      this.setState({ timeSelect: new Date() });
    }
    this.setState({ searchCondition }, () => {
      this.getListData();
    })
  }

  lookInvitedUsers(activityId) {
    this.props.history.push({ pathname: '/insuranceBroker/participantsList', state: { activityId } })
  }

  async getListData() {
    let { searchCondition, pagination } = this.state;
    let result = await API.thdList(searchCondition)
    if (result.status == 1) {
      let data = result.data;
      pagination.total = Number(data.totalNum);
      // pagination.current = searchCondition.pageIndex;
      this.setState({
        datas: data.datas,
        pagination
      })
    }
  }

  InputItemChange(e) {
    let value = e.target.value.trim();//不能缺少的声明 eval表达式需要用到value
    let { searchCondition } = this.state;
    searchCondition.title = value
    this.setState({ searchCondition })
  }

  render() {
    const {
      pagination,
      searchCondition,
      columns,
      datas,
      timeSelect
    } = this.state;
    return (
      <ConfigProvider locale={zhCN}>
        <div className="BrokerList">
          <div className="searchPane">
            <div className="leftCondition">
              <RangePicker
                className="rangePicker"
                format="YYYY-MM-DD"
                key={timeSelect}
                onChange={this.onSearchDateChange.bind(this)}
              ></RangePicker>
              <Input style={{ width: '200px', margin: '0 0 20px 20px' }} value={searchCondition.title} onChange={this.InputItemChange.bind(this)} placeholder="活动名称"></Input>
              <Select style={{ width: '200px', marginLeft: '20px' }} placeholder='请选择报名状态' value={searchCondition.signStatus} onSelect={this.onSelectChange.bind(this, 'signStatus')}>
                <Option value="0">报名中</Option>
                <Option value="1">截止报名</Option>
              </Select>
              <Select style={{ width: '200px', marginLeft: '20px' }} placeholder='请选择活动状态' value={searchCondition.status} onSelect={this.onSelectChange.bind(this, 'status')}>
                <Option value="0">未开始</Option>
                <Option value="1">进行中</Option>
                <Option value="2">已结束</Option>
              </Select>
            </div>
            <Button style={{ marginLeft: '20px' }} onClick={this.searchForData.bind(this, 'reset')}>重置</Button>
            <Button style={{ marginLeft: '20px' }} type="primary" onClick={this.searchForData.bind(this)}>搜索</Button>
          </div>
          <Table
            columns={columns}
            dataSource={datas}
            pagination={pagination}
            onChange={this.handleTableChange}
            rowKey='activityId'
          />
        </div>
      </ConfigProvider>
    )
  }
}

export default SharonList;